import { render, staticRenderFns } from "./minerRecord.vue?vue&type=template&id=208a412a&scoped=true"
import script from "./minerRecord.vue?vue&type=script&lang=js"
export * from "./minerRecord.vue?vue&type=script&lang=js"
import style0 from "./minerRecord.vue?vue&type=style&index=0&id=208a412a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208a412a",
  null
  
)

export default component.exports